import script from "./PuzzleModalVideoPlayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./PuzzleModalVideoPlayer.vue?vue&type=script&setup=true&lang=ts"

import "./PuzzleModalVideoPlayer.vue?vue&type=style&index=0&id=f1d22912&scoped=true&lang=scss"

import exportComponent from "D:\\wamp\\www\\GSALT\\gsalt-matters-ibd-denmark\\web\\modules\\vuejs\\vuejs-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1d22912"]])

export default __exports__